import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { EcardPreview } from "./CreateEcard";
import { toast } from "sonner";
import { ECARD } from "@/constants/testIds";
import { ecardStrings } from "@/lib/ecardI18n";

const TPL = {
  "rainbow-bridge": { grad: "linear-gradient(135deg,#FFE7CC,#FFD1DC 30%,#D7E8FF 70%,#E9D7FF)" },
  "golden-clouds": { grad: "linear-gradient(135deg,#FFF4D6,#F2E3C6,#FDFBF7)" },
  "starlit-meadow": { grad: "linear-gradient(135deg,#E6E9F0,#FDFBF7,#F2E3C6)" },
  "celestial-moon": { grad: "linear-gradient(135deg,#E8ECEF,#F5EAD3,#D4AF37)" },
};

export default function ViewEcard() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    apiClient.get(`/ecards/${slug}`)
      .then(({ data }) => setC(data))
      .catch((e) => setErr(e?.response?.data?.detail || "eCard not found"))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="max-w-3xl mx-auto px-6 py-32 text-center font-serif-display italic text-[var(--rb-text-muted)]">Unfolding…</div>;
  if (err) return <div className="max-w-3xl mx-auto px-6 py-32 text-center font-serif-display italic text-[var(--rb-text-muted)]">{err}</div>;

  const tpl = TPL[c.template] || TPL["rainbow-bridge"];
  const s = ecardStrings(c.language);
  return (
    <main className="relative max-w-3xl mx-auto px-6 md:px-12 py-16">
      <div className="text-center mb-10">
        <div className="tracking-celestial text-[var(--rb-gold)]">{s.a_note_arrived}</div>
      </div>
      <EcardPreview data={c} template={tpl} language={c.language} />
      <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
        <button
          onClick={async () => {
            await navigator.clipboard.writeText(window.location.href);
            toast.success("Link copied.");
          }}
          className="btn-ghost"
          data-testid={ECARD.shareLink}
        >
          Copy link
        </button>
        <Link to="/ecard" className="btn-gold">Send your own</Link>
      </div>
    </main>
  );
}
